// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__22VvM","label":"Section_label__3-WL7","contentWrap":"Section_contentWrap__3XRdI","footer":"Section_footer__2bhGv","footerInner":"Section_footerInner__3CaTg"};